<template>
  <WidgetCard title="UTFÄRDADE YRKESBEVIS" subtitle="ATT GRANSKA OCH BEKRÄFTA">
    <v-data-table
      hide-default-footer
      :headers="[
        {text: 'Avser', value: 'name', width: '280', sortable: false},
        {text: 'Avtalstillhörighet', value: 'contractType', width: '129', sortable: false},
        {text: 'Yrke', value: 'profession', width: '180', sortable: false},
        {text: 'Region', value: 'region', width: '180', sortable: false},
        {text: 'Status/Agerat', value: 'issuedBy', width: '180', sortable: false},
        {text: 'Datum', value: 'issuedOn', sortable: false, width: '100'},
        {text: '', value: 'notes', sortable: false, width: '50'}
      ]"
      :items="items"
      item-key="id"
      class="clickable"
      :items-per-page="-1"
      @click:row="clickPerson"
    >
      <!-- Application name header -->
      <template v-if="props.item && props.item.name && props.item.personalNumber" slot="item.name" slot-scope="props"
        >{{ props.item.name }} ({{ props.item.personalNumber | formatSecretPnr }})</template
      >
      <template slot="item.issuedBy" slot-scope="props">
        {{ printStatus(get(props, 'item.issuedBy', null)) }}
      </template>
      <template slot="item.issuedOn" slot-scope="props">
        <span class="widget-normal">{{ props.item.issuedOn | date }}</span>
      </template>
    </v-data-table>
  </WidgetCard>
</template>

<script>
import API from '@/services/api'
import WidgetCard from '@/components/widgets/WidgetCard.vue'
import { printStatus } from '@/helpers'
import get from 'lodash/get'
import { mapGetters } from 'vuex'

// @group Widgets
// WidgetTradeCertificates component
export default {

  name: 'WidgetTradeCertificates',

  components: {
    WidgetCard
  },

  data: () => ({
    items: []
  }),
  
  created() {
    this.getTCs()
  },

  watch: {  
    handledCasesAreVisible: {
      handler(val) {
        this.getTCs()
      }
    }
  },

  computed: {
    ...mapGetters('currentuser', ['handledCasesAreVisible'])
  },

  methods: {
    get,

    printStatus,

    clickPerson(item) {
      this.$nextTick(() =>
        this.$router.push({name: 'PersonDetail', params: {id: item.personId}, query: {tab: '2'}}).catch(() => {})
      )
    },
    /**
     * @vuese
     * Used to fetch the list of trade certificate
     * @arg called with no argument
     */
    getTCs() {

      const params = { data: { toggleMyHandledCases: this.handledCasesAreVisible } }

      API.widgetTradeCertificate(params)
        .then(res => {

          this.items = []
          
          this.items = res.data.rows.map(tc => {
            let employmentType = []
            
            if( tc.person?.educations?.filter(o => o.currentApprenticeship).length ) {
              employmentType = tc.person?.educations?.filter(o => o.currentApprenticeship).map((o => o.currentApprenticeship))
            }

            if( tc.person?.employments.length ) {
              employmentType = tc.person?.employments
            }

            return {
              personalNumber: tc.person && tc.person.personalNumber ? tc.person.personalNumber : '',
              contractType: employmentType[0]?.company?.contracttype?.name ?? '',
              personId: tc.person && tc.person.id ? tc.person.id : '',
              name:
                tc.person && tc.person.firstName && tc.person.lastName
                  ? `${tc.person.firstName} ${tc.person.lastName}`
                  : '',
              issuedBy:
                tc.createdBy && tc.createdBy.firstName && tc.createdBy.lastName
                  ? `${tc.createdBy.firstName} ${tc.createdBy.lastName}`
                  : '',
              state: tc.approveById ? tc.approveById : '',
              profession: tc.profession && tc.profession.name ? tc.profession.name : '',
              region: tc.region ? tc.region.name : '',
              issuedOn: tc.issuedOn ? tc.issuedOn : ''
            }
          })
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
</style>
